// #region imports

// --- HS Code
import { RegistrationCodeValidationResults } from './registration-code-validation-results';

// #endregion

export interface RegistrationResultModel {
  validationResult: RegistrationCodeValidationResults,
  errorMessage: string | null | undefined,
  participantId: string | null | undefined,
  surveyId: string | null | undefined,
  surveyReference: string | null | undefined
}
